export const legacyStorageGroups = [{ id: 'mock-group', name: 'Mock 업로드그룹' }]
export const legacyStorageUsage = [
  { label: '총 용량', value: '100.00 GB' },
  { label: '사용량', value: '32.50 GB' },
  { label: '촬영원본', value: '18.00 GB' },
  { label: '후기', value: '2.50 GB' },
  { label: '편집본', value: '8.00 GB' },
  { label: '고객선택사진', value: '4.00 GB' },
]
export const legacyStorageOffices = [
  { office: 'Mock 지점', source: '10.00 GB', review: '1.00 GB', edit: '4.00 GB', selected: '2.00 GB', total: '17.00 GB', allocated: '50' },
  { office: 'Mock 테스트 지점', source: '8.00 GB', review: '1.50 GB', edit: '4.00 GB', selected: '2.00 GB', total: '15.50 GB', allocated: '50' },
]
